// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"eeb273af","879":"17eed5cb"}[chunkId] + ".chunk.js";
};